// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FinancialByYear_wrapper__2MFxe","table":"FinancialByYear_table__26MOq","tableContainer":"FinancialByYear_tableContainer__jLwar"};